import { CropPortrait } from "@material-ui/icons"

export const Colors = {
    //https://material.io/design/color/the-color-system.html#tools-for-picking-colors
    Green300: "#81C784",
    Green100: "#C8E6C9",

    Red300: "#E57373",
    Red100: "#FFCDD2",

    Blue300: "#64B5F6",

    Gray300: "#E0E0E0",

    Amber300: "#FFD54F",

    Gray100: "#F5F5F5",
    Gray200: "#EEEEEE",
    Gray300: "#E0E0E0",
    Gray500: "#7b7b7b",

    Pink50: "#ffdeed",
    Pink100: "#ffaad2",
    Pink200: "#f773b0",
    Pink300: "#eb338e",
}

export const Theme = {
    Accept: Colors.Green100,
    Cancel: Colors.Red100,
    Disabled: Colors.Gray300,
    Passive: Colors.Blue300,
    Warning: Colors.Amber300
}